import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { Button, Modal } from "react-bootstrap";
import * as Admin from "../../../store/ducks/admin.duck";
import { Grid, Paper } from '@material-ui/core';
import NthQLDPHNDetail from "../../../components/NthQLDPHNDetail"
import { toAbsoluteUrl } from "../../../../_metronic";


export default function NthQLDPHNStatistics() {

  const nthqldphnStatistics = useSelector(state => state.admin.NthQLDPHNStatistics)
  const nthqldphnIssues = useSelector(state => state.admin.NthQLDPHNIssues)
  const [showDetails, setShowDetails] = useState(false);
  const [detailsHeader, setDetailsHeader] = useState('');

  const dispatch = useDispatch()
  useEffect( () => { dispatch(Admin.actions.fetchNthQLDPHNStatistics()) }, [dispatch] )
  useEffect( () => { dispatch(Admin.actions.fetchNthQLDPHNIssues()) }, [dispatch] )

  const showDetail = (lga,contentType,quarter,month) => {
    // console.log('Lga',lga)
    // console.log('contentType',contentType)
    // console.log('quarter',quarter)
    // Need to remove / character from quarter
    quarter = quarter.replace('/','-')
    dispatch(Admin.actions.fetchNthQLDPHNDetails({lga : lga, contentType : contentType, quarter : quarter, month: month}))
    if (month === '')
    {
      setDetailsHeader(lga + ' ' + contentType + ' For the period ' + quarter)
    }
    else
    {
      setDetailsHeader(lga + ' ' + contentType + ' For the period ' + quarter + ' Month ' + month)
    }
    setShowDetails(true)
  }

  function handleDetailsClose() {
    setShowDetails(false);
  }  

  const columnsIssues = [
    { field: 'id', headerName: 'ID', width: 100,  hide: true },
    { field: 'firstname', headerName: 'FirstName', width: 150  },
    { field: 'surname', headerName: 'Surname', width: 150 },
    { field: 'issue', headerName: 'Issue', width: 650 }
  ];

  
  const columnsTotal = [
    { field: 'id', headerName: 'ID', width: 100,  hide: true },
    { field: 'quarter', headerName: 'Year/Quarter', width: 130,
        renderCell: (params) => (
          <>
            {params.row.month === 'Tot' ?
              <strong>
                {params.value}
              </strong>
            :
              <>
                {params.value}
              </>
            }
          </>
        ),
    },
    { field: 'month', headerName: 'Mth', width: 80,
      renderCell: (params) => (
        <>
          {params.value === 'Tot' ?
            <strong>
              {params.value}
            </strong>
          :
            <>
              {params.value}
            </>
          }
        </>
      ),
    },
    { field: 'cairnsBookings', width: 90, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Cairns</span>
            <br />
            <span>Bookings</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Cairns','Bookings',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },
    { field: 'cairnsBookingsDNA', width: 80, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Cairns</span>
            <br />
            <span>DNA</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Cairns','BookingsDNA',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },
    { field: 'cairnsClients', width: 80, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Cairns</span>
            <br />
            <span>Clients</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Cairns','Clients',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),   
    },

    { field: 'townsvilleBookings', width: 90, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Townsville</span>
            <br />
            <span>Bookings</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Townsville','Bookings',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },
    { field: 'townsvilleBookingsDNA', width: 90, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Townsville</span>
            <br />
            <span>DNA</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Townsville','BookingsDNA',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },
    { field: 'townsvilleClients', width: 90, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Townsville</span>
            <br />
            <span>Clients</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Townsville','Clients',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),   
    },

    { field: 'mackayBookings', width: 80, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Mackay</span>
            <br />
            <span>Bookings</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Mackay','Bookings',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },
    { field: 'mackayBookingsDNA', width: 80, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Mackay</span>
            <br />
            <span>DNA</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Mackay','BookingsDNA',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },
    { field: 'mackayClients', width: 80, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Mackay</span>
            <br />
            <span>Clients</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Mackay','Clients',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),   
    },

    { field: 'unknownBookings', width: 80, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Unknown</span>
            <br />
            <span>Bookings</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Unknown','Bookings',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },
    { field: 'unknownBookingsDNA', width: 80, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Unknown</span>
            <br />
            <span>DNA</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Unknown','BookingsDNA',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },
    { field: 'unknownClients', width: 80, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Unknown</span>
            <br />
            <span>Clients</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Unknown','Clients',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),   
    },

    { field: 'totalBookings', width: 80, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Total</span>
            <br />
            <span>Bookings</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Total','Bookings',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },
    { field: 'totalBookingsDNA', width: 80, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Total</span>
            <br />
            <span>DNA</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Total','BookingsDNA',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },
    { field: 'totalClients', width: 80, renderHeader: () => {
        return (
          <div style={{ lineHeight: "1.5em" }}>
            <span>Total</span>
            <br />
            <span>Clients</span>
          </div>
        );
      }, 
      renderCell: (params) => (
        <strong>
            <div onClick={() => showDetail('Total','Clients',params.row.quarter,params.row.month)} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),   
    },
  ];

  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item><h4 style={{ marginBottom: 12 }}>NthQLDPHN Program Statistics</h4></Grid>
      </Grid>
      <img
        alt="Logo"
        src={toAbsoluteUrl("/media/misc/NthQLDPHNPlan.png")}
        style={{ marginLeft: -10 }}
      />


      <Grid container direction="row" justifyContent="space-between">
        <Grid item><h6 style={{ marginBottom: 15, marginTop: 15 }}>Region Totals Per Year/Quarter/Month (includes future bookings)</h6></Grid>
      </Grid>

      { nthqldphnStatistics ? 
        <Paper style={{ height: 600 }}>
          <DataGridPro  
            disableColumnMenu={true}
            rows={nthqldphnStatistics} columns={columnsTotal} pageSize={10} checkboxSelection={false} 
           />
        </Paper>
      : ('None')
      }

      <Grid container direction="row" justifyContent="space-between">
        <Grid item><h6 style={{ marginBottom: 15, marginTop: 15 }}>Reporting Issues Found</h6></Grid>
      </Grid>

      { nthqldphnIssues ? 
        <Paper style={{ height: 300, paddingBottom: 15 }}>
          <DataGridPro rows={nthqldphnIssues} columns={columnsIssues} pageSize={5} checkboxSelection={false} rowHeight={40} />
        </Paper>
      : ('None')
      }


      <Modal show={showDetails} onHide={handleDetailsClose} dialogClassName="editprofile-modal">
        <Modal.Header closeButton className="editprofile-modal">
          <Modal.Title>{detailsHeader} </Modal.Title>
        </Modal.Header>
        <Modal.Body className="editprofile-modal">
          <NthQLDPHNDetail/>
        </Modal.Body>
        <Modal.Footer className="editprofile-modal">
          <Button variant="secondary" onClick={handleDetailsClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )

}
